import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController, Platform } from '@ionic/angular/lazy';
import { Capacitor } from '@capacitor/core';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-order-options',
    templateUrl: './order-options.component.html',
    styleUrls: ['./order-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderOptionsComponent implements OnInit {

    @Input() order_page = null;
    on_device = false;
    @Input() printer_paper_sizes = [];

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        private platform: Platform,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {


        if(Capacitor.isNativePlatform()) {
            this.on_device = true;
        }

    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    duplicateOrder() {
        this.order_page.duplicateOrder();
        this.dismiss();
    }

    presentOrderEmailInvoiceModal() {
        this.order_page.presentOrderEmailInvoiceModal();
        this.dismiss();
    }

    printOrderInvoice(paper_size) {
        this.order_page.printOrderInvoice(paper_size);
        this.dismiss();
    }

    printXeroInvoice() {
        this.order_page.printXeroInvoice();
        this.dismiss();
    }

    printTickets(paper_size) {
        this.order_page.printTickets(paper_size);
        this.dismiss();
    }

    printGiftVouchers(paper_size) {
        this.order_page.printGiftVouchers(paper_size);
        this.dismiss();
    }

    printPackingSlip() {
        this.order_page.printPackingSlip();
        this.dismiss();
    }

    printDeliveryNote() {
        this.order_page.printDeliveryNote();
        this.dismiss();
    }

    printCollectionNote() {
        this.order_page.printCollectionNote();
        this.dismiss();
    }

    presentOrderEditModal() {
        this.order_page.presentOrderEditModal();
        this.dismiss();
    }

    presentOrderPaymentModal() {
        this.order_page.presentAddPaymentModal();
        this.dismiss();
    }

    presentReturnAddModal() {
        this.order_page.presentReturnAddModal();
        this.dismiss();
    }

    presentRefundAddModal() {
        this.order_page.presentRefundAddModal();
        this.dismiss();
    }

    presentFulfillmentAddModal() {
        this.order_page.presentFulfillmentAddModal();
        this.dismiss();
    }


    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

}
